import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAddKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAddKeyframe"><Path fillRule="evenodd" clipRule="evenodd" d="M1.18945 12.0001L12.0001 1.18945L22.8108 12.0001L12.0001 22.8108L1.18945 12.0001ZM12.75 8.25H11.25V11.25H8.25V12.75H11.25V15.75H12.75V12.75H15.75V11.25H12.75V8.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAddKeyframe;
